import { createFileRoute } from "@tanstack/react-router";

/**
 * Apple Sign In popup return URL. In popup mode, AppleID.auth.js
 * resolves the parent-window promise directly — this route is only
 * hit if Apple falls back to a full-page redirect (e.g. popup
 * blocked). We show a soft "you can close this" screen; the parent
 * window is already handling the response.
 */
const AppleCallback = () => (
  <main className="flex min-h-screen flex-col items-center justify-center px-6 py-12">
    <div className="text-center">
      <p className="font-serif text-2xl text-ink">
        You can close this window.
      </p>
      <p className="mt-2 font-sans text-sm text-ink-soft">
        We're finishing up your sign in.
      </p>
    </div>
  </main>
);

export const Route = createFileRoute("/auth/apple/callback")({
  component: AppleCallback,
});
